module.exports = __webpack_public_path__ + "profil.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/profil.png
// module id = 206
// module chunks = 0